import { FC } from "react";
import cn from "classnames";
import { useCardContext } from "../card-context";

export interface CardFooterProps {
  className?: string;
}

const CardFooter: FC<CardFooterProps> = ({ children }) => {
  const { getBemBlocksWith } = useCardContext();

  return (
    <div className={cn(getBemBlocksWith("__footer"))} data-auto="card-footer">
      {children}
    </div>
  );
};

export default CardFooter;
